import React, { useEffect, useState } from 'react'
import Typography from '../../../components/atoms/Typography'
import { Text } from '@sitecore-jss/sitecore-jss-react';
import Box from '../../../components/molecules/Box';
import Button from '../../../components/atoms/Button';
import useStyles from './style';
import Link from '../../../components/atoms/Link';
import ButtonMUI from '../../../components/atoms/Button';
import Slider from 'react-slick';
import { settings } from './config';
import 'slick-carousel/slick/slick.css';
import '../../../../styles/themes/slick-themes.css';
import Picture from '../../../components/atoms/Picture';
import aspectRatios from '../../../utils/AspectRatios';
import { getLocalStorage } from '../../../../utils/localStorage';
import ItineraryBuilder from '../ItineraryBuilder';
import { getDictionaryText } from '../../../utils/getDictionaryText';
import { useTheme } from '@material-ui/core/styles';
// import ItineraryPlaceholder from '../../../../assets/svg/ItineraryPlaceholder.svg';
import ItineraryMobImagePlaceholder from '../../../../assets/images/ItineraryMobImagePlaceholder.jpg'
import ItineraryPlaceholder from '../../../../assets/images/ItineraryImagePlaceholder.jpg'
import { useSelector, useDispatch } from 'react-redux';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { breakpoints } from '../../../../styles/themes/vad/constants';
import { useHistory } from 'react-router-dom';
import { canUseDOM } from '../../../utils/canUseDOM';
import { getItineraryPlaceResultStart } from '../ItineraryBuilderMap/redux/actions';
import { get } from 'lodash';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

const ItinerarySubLayout = (props) => {
  const {
    placeholders,
  } = props.rendering;
  const language = get(props, 'sitecoreContext.language', 'en');
  const dispatch = useDispatch();
  const placesItineraryItems = useSelector(state => state.ItineraryBuilderMapReducer.placesItinerary);
  const itineraryInfobox = placeholders && placeholders['itinerary-infobox'];
  const { cta2, longTitle, shortTitle, segmentText, itineraryMapCTA } = Array.isArray(itineraryInfobox) && itineraryInfobox[0].fields
  const classes = useStyles();
  const reduxItineraryList = useSelector((state) => state.FilteredDataReducer.itineraryList);
  const itineraryList = placesItineraryItems && placesItineraryItems.length > 0 ? placesItineraryItems : reduxItineraryList && reduxItineraryList.length > 0 ? reduxItineraryList : JSON.parse(getLocalStorage('itineraryList') || '[]')
  const [itineraryItems, setItineraryItems] = useState(null)
  const [placesItineraryResult, setPlacesItineraryResult] = useState(null)
  const [multiFilterID, setMultiFilterID] = useState(1)
  const [modalPop, setmodalPop] = useState(false)
  const theme = useTheme();
  const isRTL = theme && theme.direction === 'rtl';
  const slickSetting = {
    ...settings,
    rtl: isRTL,
    initialSlide: isRTL ? 2 : 0,
  }
  const history = useHistory()

  const getRequestData = (offset = 0, limit = 99, placesId = []) => {
    return {
      'contentType': 'favorites',
      // 'language': lang ?? 'en',
      'language': language,
      'facetFields': [],
      'itemIDs': placesId,
      'limit': limit,
      'offset': offset,
      'filters': [],
      'isPreviewMode': false,
    }
  }

  useEffect(() => {
    if ((itineraryItems && itineraryItems.length === itineraryList.length) && ((placesItineraryItems && placesItineraryItems.length) === (placesItineraryResult && placesItineraryResult.length))) return
    let firstValuesStrings = Array.isArray(itineraryList) && itineraryList.map(item => Object.values(item.newdays || {}).flat()) || [];
    firstValuesStrings = [].concat(...firstValuesStrings);
    dispatch(getItineraryPlaceResultStart(getRequestData(0, 50, firstValuesStrings)));
    if (placesItineraryItems) setPlacesItineraryResult(placesItineraryItems || [])
    setItineraryItems(itineraryList || [])
  }, [itineraryList])

  const isMobile = useMediaQuery(`(max-width:${breakpoints.values.lg}px)`);

  let placesExist;
  const renderImage = (newdays) => {
    placesExist = Object.values(newdays ?? {}).some(place => place.length > 0);
    if (!placesExist) {
      const imagePlaceholder = isMobile ? ItineraryMobImagePlaceholder : ItineraryPlaceholder
      return imagePlaceholder
    } else {
      let firstValueString = null
      Object.keys(newdays).forEach(key => {
        if (newdays[key].length > 0 && placesItineraryResult) {
          firstValueString = newdays[key][0]?.thumbnailImage ?? { src: '' };
          return;
        }
      });
      return firstValueString
    }
  }
  const getRandomNumber = () => {
    setMultiFilterID(Math.random())
  }

  useEffect(() => {
    getRandomNumber()
  }, [itineraryItems])

  const createSVG = (type = '', fill = '', customClass = '') => {
    switch (type) {
      case 'boxImage':
        return (
          <svg className={customClass} width="454" height="434" viewBox="0 0 454 434" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M98.5314 65.5508C187.624 -111.185 359.95 -168.143 482.445 -196.894C450.492 -257.357 396.856 -309 331.562 -309C185.208 -309 90.6191 -97.7753 90.6191 52.8665C90.6191 57.0947 90.6789 61.2621 90.7393 65.4903H98.5314V65.5508Z" fill="black" fillOpacity="0.05" />
            <path d="M365.249 657.458V635.291V557.735L365.249 21.0059C365.249 21.0059 357.517 21.0059 357.457 21.0663C236.955 123.024 68.5559 176.057 0 195.627L0 203.359C0.241607 203.902 0.483184 204.446 0.724791 204.99C59.0124 322.229 67.589 454.207 66.7434 582.983C66.7434 580.325 66.8038 587.936 66.7434 584.433C66.7434 585.037 66.7434 585.278 66.7434 583.829L66.5023 699.438H66.6225C66.6829 748.846 66.6828 810.637 66.562 822.415C64.2668 922.139 144.48 1004.28 244.264 1004.28L458.448 1004.28C412.845 966.715 365.249 855.697 365.249 657.458Z" fill="black" fillOpacity="0.05" />
          </svg>
        )
        break;
      case 'arrowIcon':
        return (
          <svg className={`${customClass} customSVG`} width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.64 0L14.4 6L8.64 12L7.82784 11.154L12.1939 6.6H0V5.4H12.1939L7.82784 0.846L8.64 0Z" fill={fill} />
          </svg>
        )
        break;
      case 'boxImage2':
        return (
          <svg className={customClass} width="114" height="436" viewBox="0 0 114 436" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M98.5314 105.551C187.624 -71.1846 359.95 -128.143 482.445 -156.894C450.492 -217.357 396.856 -269 331.562 -269C185.208 -269 90.6191 -57.7753 90.6191 92.8665C90.6191 97.0947 90.6789 101.262 90.7393 105.49H98.5314V105.551Z" fill="black" fillOpacity="0.05" />
            <path d="M365.249 697.458V675.291V597.735L365.249 61.0059C365.249 61.0059 357.517 61.0059 357.457 61.0663C236.955 163.024 68.5559 216.057 0 235.627L0 243.359C0.241607 243.902 0.483184 244.446 0.724791 244.99C59.0124 362.229 67.589 494.207 66.7434 622.983C66.7434 620.325 66.8038 627.936 66.7434 624.433C66.7434 625.037 66.7434 625.278 66.7434 623.829L66.5023 739.438H66.6225C66.6829 788.846 66.6828 850.637 66.562 862.415C64.2668 962.139 144.48 1044.28 244.264 1044.28H458.448C412.845 1006.71 365.249 895.697 365.249 697.458Z" fill="black" fillOpacity="0.05" />
          </svg>
        )
        break;
      case 'time':
        return (
          <svg className={customClass} width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.5423 7H11.7441V13.2131L18.0377 17L18.9368 15.5213L13.5423 12.3115V7Z" fill="black" />
            <ellipse cx="12.7716" cy="12" rx="10.2752" ry="10" stroke="black" strokeWidth="2" />
          </svg>
        )
        break;
      default:
        return <></>
    }
  }

  const emptyItenerary = () => {
    return (
      <Box className='emptylistIternary'>
        <Box className='innerWrapper'>
          <Typography
            variant={'body2'}
            component={'p'}
            className={'subHeading'}
          >
            <Text field={segmentText} />
          </Typography>
          <Typography
            variant={'h2'}
            component={'h2'}
            className={'mainHeading'}
          >
            <Text field={longTitle} />
          </Typography>
          <Box className='buttonWrapper'>
            <Button
              component="span"
              className='createButton'
              onClick={() => {
                setmodalPop(true)
              }}
              buttonType={'primary'}
              hasBorder={false}
              animateSettings={{
                willAnimate: false,
              }}
            >
              {getDictionaryText('Create')}
            </Button>
            <Button
              field={cta2}
              component="span"
              className='viewButton'
              buttonType={'primary'}
              hasBorder={false}
              animateSettings={{
                willAnimate: false,
              }}
            >
            </Button>

          </Box>
          <Box className='mobileButtonWrapper'>
            <Typography
              className="link"
              isCustom={true}
              onClick={() => {
                setmodalPop(true)
              }}
            >
              {createSVG('arrowIcon', '#FF8707', '')}
              <Typography variant="body2Bold" component="span" >{getDictionaryText('Create')}</Typography>
            </Typography>
            <Link customHref={cta2?.value?.href} className="link" isCustom={true} > {createSVG('arrowIcon', '#FF8707', '')} <Typography variant="body2Bold"
              component="span" >{cta2?.value?.text}</Typography></Link>
          </Box>
          <Box className='boxImage'>
            {createSVG('boxImage')}
          </Box>
        </Box>
      </Box>
    )
  }

  const handleClick = (id) => {
    if (canUseDOM) {
      const redirectURL = `${window.location.origin}${itineraryMapCTA?.value?.href}?itineraryId=${id}`;
      window.location.href = redirectURL;
    }
  }

  const withItinerary = () => {
    return (
      <Box className='itenaryListing'>
        <Box className='contentSection'>
          <Typography
            variant={'h4'}
            component={'span'}
          >
            <Text field={shortTitle} />
          </Typography>
          <ButtonMUI
            buttonType={'form'}
            type={'submit'}
            hasBorder={false}
            className='create-btn'
            size={'small'}
            field={{ value: { text: getDictionaryText('Create') } }}
            onClick={() => {
              if (canUseDOM) {
                const redirectURL = `${window.location.origin}/${language}/itinerary-map`;
                window.location.href = redirectURL;
              }
            }}
          />
          <ButtonMUI
            buttonType={'form'}
            type={'submit'}
            hasBorder={false}
            className='view-btn'
            size={'small'}
            field={cta2}
          />
          <Box className='bgImage'>
            {createSVG('boxImage2')}
          </Box>
        </Box>
        <Box className='sectionSlider'>
          <Box className='innerBox'>
            <Typography
              className='mainHeading'
              variant={'h5Bold'}
              component={'span'}
            >
              <Text field={{ value: getDictionaryText('MyItineraries') }} />
            </Typography>

            <Slider key={multiFilterID} {...slickSetting}>
              {placesItineraryResult && [...placesItineraryResult].reverse().map(items => {
                const { id, trip_name, trip_days, newdays } = items
                const tripDays = Number(trip_days) > 1 ? `${trip_days} days` : `${trip_days} day`
                let truncateTitle = trip_name
                const charactersLimit = isMobile ? 42 : 60
                if (truncateTitle.length > charactersLimit) {
                  truncateTitle = trip_name.substring(0, charactersLimit);
                  truncateTitle = truncateTitle + '...'
                }
                let renderPicture = renderImage(newdays) ?? null
                renderPicture = renderPicture && typeof renderPicture === 'string' ? renderPicture : { value: renderPicture } || null
                return (
                  <>
                    <Box className={`sliderInner ${isRTL ? 'rtlClass' : ''}`} onClick={() => handleClick(id)}>
                      <Box className={`imageWrapper ${'show-placeholder-img'}`}>
                        {renderPicture &&
                          <Picture
                            media={{
                              image: renderPicture,
                              aspectRatio: aspectRatios['3x2-card'],
                              fallbackBackgroundNeeded: placesExist ? true : false,
                            }}
                            // alternateAltText={
                            //   typeof title === 'object' && title ? title.value : title
                            // }
                            isParalax={false}
                          />
                        }
                      </Box>
                      <Box className='contentWrapper'>
                        <Typography
                          className="titleHead"
                          variant={'body1Bold22'}
                          component={'p'}
                        >
                          <Text field={{ value: truncateTitle }} />
                        </Typography>
                        <Typography
                          className="titleSmall"
                          variant={'body3'}
                          component={'p'}
                        >
                          {createSVG('time')}  <Text field={{ value: tripDays }} />
                        </Typography>
                      </Box>
                    </Box>
                  </>
                )
              })
              }
            </Slider>
            <Box className='mobileButtonWrapper'>
              <Typography
                className="link"
                isCustom={true}
                onClick={() => {
                  setmodalPop(true)
                }}
              >
                {createSVG('arrowIcon', '#FF8707', '')}
                <Typography variant="body2Bold" component="span" >{getDictionaryText('Create')}</Typography>
              </Typography>
              <Link customHref={cta2?.value?.href} className="link" isCustom={true} > {createSVG('arrowIcon', '#FF8707', '')} <Typography variant="body2Bold"
                component="span" >{cta2?.value?.text}</Typography></Link>
            </Box>
          </Box>
        </Box>
      </Box >
    )
  }

  return (
    <Box className={classes.iternaryLayout}>
      {placesItineraryResult && itineraryItems && (
        Array.isArray(itineraryItems) && itineraryItems.length === 0 ? (
          emptyItenerary()
        ) : (
          withItinerary()
        )
      )}

      <ItineraryBuilder navigateOnSubmit={true} customClass={'createItinerary'} open={modalPop} handleExit={() => { setmodalPop(false) }} itineraryList={itineraryList}
        isCreateItinerary={true}
      />
    </Box>
  )
}

export default withErrorBoundary(withSitecoreContext()(ItinerarySubLayout));
